import { useState } from 'react';
import RoundCheckBox from '../CustomCheckbox/RoundCheckbox';
import Select from 'react-select';
import { onSelectPermissionOptions } from '../../constants/enums/Permissions';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import loadingGif from '../../assets/Other/loading.gif';
import classNames from 'classnames';
import request from '../../utils/APIHelper/request';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import { currentUser } from '../../utils/Auth/auth';

const defaultAdmin = {
  email: '',
  name: '',
  shipments: onSelectPermissionOptions[1],
  administrators: false,
  containerBranchChange: false,
  canParTracking: false,
  reports: false,
  refund: false,
  agentList: false,
};
const AdminAddingModal = ({ admins, setAdmins }) => {
  const [tempAdmin, setTempAdmin] = useState(defaultAdmin);
  const [loading, setLoading] = useState(false);

  const handleChange = (field, value) => {
    setTempAdmin((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const onSave = async () => {
    if (tempAdmin.name && tempAdmin.email) {
      if (
        tempAdmin.shipments?.value !== 'disabled' ||
        tempAdmin.reports ||
        tempAdmin.containerBranchChange ||
        tempAdmin.agentList ||
        tempAdmin.refund
      ) {
        const result = await request({
          url: `${controllers.auth}createAdmin`,
          body: {
            email: tempAdmin.email,
            name: tempAdmin.name,
            shipments: tempAdmin.shipments.value,
            administrators: tempAdmin.administrators,
            containerBranchChange: tempAdmin.containerBranchChange,
            canParTracking: tempAdmin.canParTracking,
            reports: tempAdmin.reports,
            refund: tempAdmin.refund,
            agentList: tempAdmin.agentList,
          },
          type: requestTypes.post,
          setLoading,
        });
        if (result.code !== responseTypes.error) {
          setAdmins([...admins, result]);
          toast.success(`Admin ${tempAdmin.name} has been added!`);
          Swal.close();
          window.location.reload();
        } else {
          toast.error(result.message);
        }
      } else {
        toast.error('Admin must have at least one permission to be added!');
      }
    } else {
      toast.error('Email and name are mandatory fields!');
    }
  };

  return (
    <div>
      Email:
      <input
        value={tempAdmin.email}
        onChange={(e) => handleChange('email', e.target.value)}
        className="block w-2/3 pb-1 px-2 mx-auto mt-2 mb-5 border-b-[1px] border-b-blue-700 focus:outline-none focus:border-blue-300"
        type="text"
        placeholder="example@meest.com..."
      />
      Name:
      <input
        value={tempAdmin.name}
        onChange={(e) => handleChange('name', e.target.value)}
        className="block w-2/3 pb-1 px-2 mx-auto mt-2 mb-5 border-b-[1px] border-b-blue-700 focus:outline-none focus:border-blue-300"
        type="text"
        placeholder="John Doe..."
      />
      Shipments:
      <Select
        value={tempAdmin.shipments}
        onChange={(value) => handleChange('shipments', value)}
        className="w-2/3 mx-auto mt-2 mb-5"
        placeholder="Select shipment permission"
        options={onSelectPermissionOptions}
      />
      Permissions:
      <div
        className={classNames(
          'flex items-center my-2',
          currentUser?.role !== 'master' && 'hidden',
        )}
      >
        <RoundCheckBox
          value={tempAdmin.administrators}
          changeFieldValue={(value) => handleChange('administrators', value)}
        />
        <div className="mx-1">
          Admin access
          <span className="text-red-500">{' (Not recommended!)'}</span>
        </div>
      </div>
      <div className="flex items-center my-2">
        <RoundCheckBox
          value={tempAdmin.agentList}
          changeFieldValue={(value) => handleChange('agentList', value)}
        />
        <div className="mx-1">{`Agents map`}</div>
      </div>
      <div className="flex items-center my-2">
        <RoundCheckBox
          value={tempAdmin.containerBranchChange}
          changeFieldValue={(value) =>
            handleChange('containerBranchChange', value)
          }
        />
        <div className="mx-1">{`Change container's branch`}</div>
      </div>
      <div className="flex items-center my-2">
        <RoundCheckBox
          value={tempAdmin.reports}
          changeFieldValue={(value) => handleChange('reports', value)}
        />
        <div className="mx-1">{`Get reports`}</div>
      </div>
      <div className="flex items-center my-2 mb-10">
        <RoundCheckBox
          value={tempAdmin.refund}
          changeFieldValue={(value) => handleChange('refund', value)}
        />
        <div className="mx-1">{`Get refund informations`}</div>
      </div>
      {loading ? (
        <div className="w-5 h-5 float-left inline-block my-2 mx-5">
          <img className="w-full h-full" src={loadingGif} />
        </div>
      ) : (
        <div
          onClick={onSave}
          className={classNames(
            'bg-red-800 text-white text-md inline-block px-5 py-2 rounded-[5px] cursor-pointer float-left hover:bg-red-900 hover:transition-all hover:duration-300',
          )}
        >
          Save
        </div>
      )}
      <div
        onClick={() => Swal.close()}
        className="text-white text-md bg-blue-900 inline-block px-5 py-2 rounded-[5px] cursor-pointer float-right hover:bg-blue-800 hover:transition-all hover:duration-300"
      >
        Cancel
      </div>
    </div>
  );
};

export default AdminAddingModal;
